import { getHandler } from "./handlers";
import type { DriverSocketMsgType, DriverSocketMsg as msg } from "@libs/types/message";
import { generateMessageID } from "@libs/utils/tools";
// @ts-ignore
Map.prototype.toJSON = function () {
    const obj = {};
    for (let [key, value] of this) {
        // @ts-ignore
        obj[key] = value;
    }
    return obj;
};


export interface socketMsg<T> {
    ID: string;
    Type: number;
    Data: T;
    Error: string;
}

export class FakeSocketModel {
    public Run() {
        console.log('debug:', `run`)
    }


    constructor() {
        Promise.resolve().then(() => {
            this.onopen(new Event('open'))
        })
        // deviceNode.setDevice(deviceNode.getHe3HidPath())
        // deviceHid.setDevice(deviceNode)
    }


    public send(msgStr: string) {
        const msg = JSON.parse(msgStr) as msg<any>;
        const handler = getHandler(msg.Type);
        handler(msg.Data).then(resp => {
            const retMsg = {
                ID: msg.ID,
                Type: msg.Type,
                Data: resp,
                Error: '',
            } as socketMsg<any>;
            this.onmessage({ data: JSON.stringify(retMsg) } as MessageEvent)
        }).catch((err) => {
            console.log(err);
            const retMsg = {
                ID: msg.ID,
                Type: msg.Type,
                Data: null,
                Error: err.message,
            } as socketMsg<any>;
            this.onmessage({ data: JSON.stringify(retMsg) } as MessageEvent)
        });

    }

    public sendMsg(msg: socketMsg<any>) {
        this.onmessage({ data: JSON.stringify(msg) } as MessageEvent)
    }

    public sendMsgData(Type: DriverSocketMsgType, Data: any) {
        const data: socketMsg<any> = {
            ID: generateMessageID(),
            Type: Type,
            Data: Data,
            Error: ""
        }
        this.sendMsg(data)
    }

    public onmessage = (e: MessageEvent) => {
        console.log('debug:', `onmessage`, e)
    }

    public onerror = (_e: Event) => {
        console.log('debug:', `onerror`)
    }

    public onopen = (_e: Event) => {
        console.log('debug:', `onopen`)
    }

    public onclose = (_e: CloseEvent) => {
        console.log('debug:', `onclose`)
    }
    public close = () => {
        console.log('debug:', `close`)
    }
}

export const fakeSocket = new FakeSocketModel();

export const fnTest = () => {
    console.log('debug:', `fnTest33`)
}


